<template>
  <!-- O COMPONENTE NÃO POSSUI VALIDAÇÕES (COMPRIMENTO E SEQUÊNCIA VÁLIDA) POIS ACEITA COMPRIMENTO PARCIAL -->
  <NxInput
    name="document"
    type="text"
    :label="label"
    placeholder="Digite o CPF ou CNPJ"
    v-mask="['###.###.###-##', '##.###.###/####-##']"
    :value="localValue"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxInput>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import { advancedOnException } from '@/components/tools/Utils'
import ManagerRepository from '@/shared/http/repositories/configurations/person.js'
import { loading } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputDocument',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'CPF/CNPJ:'
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
      this.checkIfAlreadyPersonAndPersonType()
    },
    async checkIfAlreadyPersonAndPersonType () {
      await this.checkIfAlreadyPerson()
      const tipoPessoa = Tools.checkDocumentType(this.localValue)
      this.$emit('tipoPessoa', tipoPessoa)
    },
    async checkIfAlreadyPerson () {
      if (
        (typeof this.localValue !== 'string' && !this.localValue) ||
        !this.isValidDocument()
      ) {
        this.$emit('dadosPessoa', null)
        return
      }

      try {
        loading.push()

        const { data } = await ManagerRepository.GetByDocument(
          this.localValue.replace(/\D/g, '')
        )

        if (data && data.content.length > 0) {
          this.$emit('dadosPessoa', data.content[0])
        } else {
          this.$emit('dadosPessoa', null)
        }
      } catch (err) {
        advancedOnException(err, this.$lang)
      } finally {
        loading.close()
      }
    },
    isValidDocument () {
      const cleanedDocument = this.localValue.replace(/\D/g, '')
      return cleanedDocument.length === 11 || cleanedDocument.length === 14
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputDocument.vue